import { openDB } from 'idb';

const DB_NAME = 'UserPreferencesDB';
const STORE_NAME = 'preferences';
const DB_VERSION = 1;

const initDB = async () => {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });
};

export const setPreference = async (key, value) => {
  try {
    const db = await initDB();
    await db.put(STORE_NAME, value, key);
    return true;
  } catch (error) {
    console.error('Error setting preference:', error);
    return false;
  }
};

export const getPreference = async (key) => {
  try {
    const db = await initDB();
    return await db.get(STORE_NAME, key);
  } catch (error) {
    console.error('Error getting preference:', error);
    return null;
  }
};

export const PREFERENCE_KEYS = {
  REMEMBER_ME: 'rememberMe'
}; 